<div class="category-card" [ngClass]="scoreClass">
  <!-- Header area: coloured background scoped here, does NOT extend into KPI cards -->
  <div class="category-card__header-area" [ngClass]="scoreBgClass">
    <!-- Top row: icon + name (left) | trend arrow + chevron (right) -->
    <div class="category-card__top-row">
      <div class="category-card__title">
        <mc-icon [attr.icon]="categoryIcon" size="20"></mc-icon>
        <span class="mds-text--medium-bold">{{ data.categoryName }}</span>
      </div>
      <div class="category-card__actions">
        <button
          type="button"
          class="category-card__toggle"
          (click)="toggle()"
          [attr.aria-expanded]="isExpanded()"
          aria-label="Toggle KPI cards">
          <mc-icon [attr.icon]="isExpanded() ? 'chevron-up' : 'chevron-down'" size="20"></mc-icon>
        </button>
      </div>
    </div>

    <!-- Score displayed below the name, large bold -->
    <div class="category-card__score">
      <span [ngClass]="scoreClass + '-text'">{{ displayScore }}</span>
      <span class="category-card__score-max mds-neutral--weak__text-color"> / {{ displayMax }}</span>
    </div>

    <div class="category-card__progress-bar">
      <div class="category-card__progress-fill" [ngClass]="scoreClass + '-fill'" [style.width]="progressWidth"></div>
    </div>
  </div>

  <!-- KPI cards: neutral/white background, not tinted -->
  @if (isExpanded()) {
    <div class="category-card__kpis">
      @for (kpi of visibleKpis; track kpi.kpiId) {
        <app-vsc-kpi-trend-card [data]="kpi" />
      }
    </div>
  }
</div>
